function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { setOpacity } from "../lib/color";
export const pressableColors = {
  black: '#000000',
  white: '#ffffff',
  blue500: '#5469d4',
  blue600: '#3d4eac',
  cyan400: '#3a97d4',
  gray50: '#f7fafc',
  gray100: '#e3e8ee',
  gray300: '#a3acb9',
  gray700: '#3c4257',
  gray900: '#1a1f36',
  orange400: '#e56f4a',
  orange500: '#c44c34',
  red500: '#cd3d64',
  red600: '#a41c4e'
};
export const defaultPressableTheme = {
  color: {
    primary: pressableColors.blue500,
    hover: pressableColors.gray900,
    default: pressableColors.gray700,
    disabled: pressableColors.gray300,
    negative: pressableColors.red500,
    onPrimary: pressableColors.white,
    onNegative: pressableColors.white
  },
  fill: {
    primary: pressableColors.blue500,
    disabled: pressableColors.gray50,
    warning: pressableColors.orange400,
    negative: pressableColors.red500,
    inset: pressableColors.gray100,
    base: pressableColors.white
  },
  keyline: {
    base: setOpacity(pressableColors.gray700, 0.16),
    primary: pressableColors.blue500,
    negative: pressableColors.red500,
    warning: pressableColors.orange500,
    focus: setOpacity(pressableColors.cyan400, 0.28)
  },
  shadow: {
    key: setOpacity(pressableColors.black, 0.12),
    ambient: setOpacity(pressableColors.gray700, 0.08),
    focus: setOpacity(pressableColors.cyan400, 0.36)
  }
};
export const pressableColors2021 = {
  black: '#000000',
  white: '#ffffff',
  blue500: '#635bff',
  blue600: '#533fdb',
  cyan400: '#0196ed',
  gray50: '#f6f8fa',
  gray100: '#ebeef1',
  gray300: '#a3acba',
  gray700: '#404452',
  gray900: '#1a1b25',
  orange400: '#ed6804',
  orange500: '#c84801',
  red500: '#df1b41',
  red600: '#b3063d'
};
export const defaultPressableTheme2021 = {
  color: {
    primary: pressableColors2021.blue500,
    hover: pressableColors2021.gray900,
    default: pressableColors2021.gray700,
    disabled: pressableColors2021.gray300,
    negative: pressableColors2021.red500,
    onPrimary: pressableColors2021.white,
    onNegative: pressableColors2021.white
  },
  fill: {
    primary: pressableColors2021.blue500,
    disabled: pressableColors2021.gray50,
    warning: pressableColors2021.orange400,
    negative: pressableColors2021.red500,
    inset: pressableColors2021.gray100,
    base: pressableColors2021.white
  },
  keyline: {
    base: setOpacity(pressableColors2021.gray700, 0.16),
    primary: pressableColors2021.blue500,
    negative: pressableColors2021.red500,
    warning: pressableColors2021.orange500,
    focus: setOpacity(pressableColors2021.cyan400, 0.28)
  },
  shadow: {
    key: setOpacity(pressableColors2021.black, 0.12),
    ambient: setOpacity(pressableColors2021.gray700, 0.08),
    focus: setOpacity(pressableColors2021.cyan400, 0.36)
  }
};
export const mergeThemes = (theme, add) => ({
  color: _objectSpread(_objectSpread({}, theme.color), add.color || {}),
  fill: _objectSpread(_objectSpread({}, theme.fill), add.fill || {}),
  keyline: _objectSpread(_objectSpread({}, theme.keyline), add.keyline || {}),
  shadow: _objectSpread(_objectSpread({}, theme.shadow), add.shadow || {})
});
export const cloneTheme = theme => mergeThemes(theme, {});
export const PressableThemeContext = /*#__PURE__*/React.createContext(defaultPressableTheme);
export const PressableThemeProvider = ({
  children,
  theme
}) => {
  const parentTheme = React.useContext(PressableThemeContext);
  const value = React.useMemo(() => mergeThemes(parentTheme, theme), [parentTheme, theme]);
  return /*#__PURE__*/React.createElement(PressableThemeContext.Provider, {
    value: value
  }, children);
};